import { render } from "./Contact.vue?vue&type=template&id=ff37a678"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=ff37a678&lang=css"

import exportComponent from "E:\\backup\\Programowanie\\kurs\\vue\\siatka-koncentracji\\siatka-koncentracji\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__